import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'toDateLarge'
})
export class ToDateLargePipe implements PipeTransform {

  transform(value: string ): string {
      if (value != null && value.trim() != "") {
          let ret = "";
          ret =  moment(value).format('DD- MMMM -YYYY') ;

          return ret;
      }
      return "";
  }

}
